import apiService from 'src/enviroment';
import { loaderService } from 'src/services/loaderService';

const getQueueEntries = async () => {
  loaderService.show();
  const response = await apiService.get(
    'insights/admin/entradas/sistema/?tipo=entradas_unidad',
  );
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const rejectEntries = async (params) => {
  loaderService.show();
  const response = await apiService.put('insights/admin/entradas/sistema/', params);
  try {
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
  }
};

export { getQueueEntries, rejectEntries };
